var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading 1",
    clipPath: "url(#clip0_1690_13397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.7275 34.3635H55.6365C53.8292 34.3635 52.3638 35.829 52.3638 37.6363C52.3638 39.4436 53.8292 40.909 55.6365 40.909H68.7275C70.5348 40.909 72.0002 39.4436 72.0002 37.6363C72.0002 35.829 70.5351 34.3635 68.7275 34.3635Z",
    fill: "#2D50A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3637 34.3635H3.27274C1.46543 34.3635 0 35.829 0 37.6363C0 39.4436 1.46543 40.909 3.27274 40.909H16.3637C18.171 40.909 19.6365 39.4436 19.6365 37.6363C19.6365 35.829 18.171 34.3635 16.3637 34.3635Z",
    fill: "#73A1FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M56.8279 12.1805L47.5709 21.4375C46.2928 22.7153 46.2928 24.7875 47.5709 26.0656C48.2098 26.7048 49.0475 27.0245 49.8848 27.0245C50.7225 27.0245 51.5601 26.7052 52.199 26.0656L61.456 16.8087C62.7341 15.5309 62.7341 13.4586 61.456 12.1805C60.1782 10.9024 58.106 10.9024 56.8279 12.1805Z",
    fill: "#355EC9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.9998 57.2727C34.1925 57.2727 32.7271 58.7381 32.7271 60.5454V67.0909C32.7271 68.8982 34.1925 70.3637 35.9998 70.3637C37.8071 70.3637 39.2725 68.8982 39.2725 67.0909V60.5454C39.2725 58.7381 37.8071 57.2727 35.9998 57.2727Z",
    fill: "#C4D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.8007 49.2071L10.544 58.4641C9.26592 59.7422 9.26592 61.8141 10.544 63.0922C11.1829 63.7311 12.0206 64.0507 12.8583 64.0507C13.696 64.0507 14.5336 63.7311 15.1722 63.0922L24.4288 53.8353C25.7069 52.5572 25.7069 50.4852 24.4288 49.2071C23.151 47.929 21.0788 47.929 19.8007 49.2071Z",
    fill: "#C4D9FD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.0003 1.63623C34.193 1.63623 32.7275 3.10166 32.7275 4.90897V17.9999C32.7275 19.8073 34.193 21.2727 36.0003 21.2727C37.8076 21.2727 39.273 19.8073 39.273 17.9999V4.90897C39.273 3.10166 37.8076 1.63623 36.0003 1.63623Z",
    fill: "#3D6DEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.1727 12.1805C13.8949 10.9024 11.8226 10.9024 10.5445 12.1805C9.26641 13.4586 9.26641 15.5305 10.5445 16.8087L19.8012 26.0656C20.44 26.7048 21.2777 27.0245 22.1154 27.0245C22.9527 27.0245 23.7907 26.7048 24.4293 26.0656C25.7074 24.7878 25.7074 22.7156 24.4293 21.4375L15.1727 12.1805Z",
    fill: "#5286FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1690_13397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.56d2c069e38b926b83cb9723e42de89e.svg";
export { ForwardRef as ReactComponent };